import { createTheme } from '@mui/material/styles';

export const getAppTheme = (mode = 'light') => {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: '#2563EB',
        light: '#4F83F1',
        dark: '#1D4ED8',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#2563EB',
        contrastText: '#FFFFFF',
      },
      success: {
        main: '#16A34A',
      },
      warning: {
        main: '#D97706',
      },
      error: {
        main: '#DC2626',
      },
      background: {
        default: isDark ? '#0F172A' : '#F5F6F8',
        paper: isDark ? '#111827' : '#FFFFFF',
      },
      text: {
        primary: isDark ? '#F8FAFC' : '#1F2430',
        secondary: isDark ? '#CBD5E1' : '#6B7280',
      },
      divider: isDark ? '#1E293B' : '#E5E7EB',
    },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      h4: { fontWeight: 700 },
      h5: { fontWeight: 700 },
      h6: { fontWeight: 600 },
      button: { fontWeight: 600, textTransform: 'none' },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
          },
          contained: {
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: isDark ? '0 1px 3px rgba(15, 23, 42, 0.42)' : '0 1px 3px rgba(15, 23, 42, 0.08)',
            border: `1px solid ${isDark ? '#1E293B' : '#E5E7EB'}`,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          // <html> has no background by default — CssBaseline only themes
          // <body>. Without this, a scrollbar or rounding at the page edge
          // can expose the browser's default white through <html>, showing
          // as a stray white sliver in dark mode.
          html: {
            backgroundColor: isDark ? '#0F172A' : '#F5F6F8',
          },
        },
      },
    },
  });
};

const theme = getAppTheme();

export default theme;
